import styled from '@emotion/styled'

import {
  Container as ItemContainer,
  Image as ItemImage,
  Label as ItemLabel
} from './Item/style'

import { mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${mediaMax.md} {
    justify-content: center;
    gap: 6rem;
  }

  ${mediaMax.xs} {
    gap: .75rem;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &.small {
    width: auto;

    ${ItemContainer} {
      width: auto;
      margin-right: 0;
      margin-left: 20px;
      ${mediaMax.xs} {
        margin-left: .75rem;
      }
    }

    ${ItemImage} {
      width: 2rem;
      height: 2rem;
    }

    ${ItemLabel} {
      display: none;
    }
  }
`
